import React from "react";

interface Props {
  page: number;
  totalPages: number;
  pageSize: number;
  total: number;
  disabled?: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const TablePagination: React.FC<Props> = ({ page, totalPages, pageSize, total, disabled, onPageChange, onPageSizeChange }) => {
  const pages = Math.max(1, totalPages);
  return (
    <div className="account-table-pagination">
      <span className="account-table-total">{total} registro(s)</span>
      <nav aria-label="Paginação da tabela">
        <button type="button" className="btn btn-outline-secondary" disabled={disabled || page <= 1} onClick={() => onPageChange(page - 1)}>Anterior</button>
        <span aria-live="polite">Página {page} de {pages}</span>
        <button type="button" className="btn btn-outline-secondary" disabled={disabled || page >= pages} onClick={() => onPageChange(page + 1)}>Próximo</button>
      </nav>
      <label>Linhas por página
        <select aria-label="Linhas por página" className="form-select" value={pageSize} disabled={disabled} onChange={(event) => onPageSizeChange(Number(event.target.value))}>
          <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
        </select>
      </label>
    </div>
  );
};

export default TablePagination;
